/**
 * Static files added to the export zip file that is saved to AVS.
 *
 * @note Below are some not-static files that can also get added to the export zip.
 * - `${client}_${client}${application}.properties`: Stores application properties.
 * - `${csvData[cf].name}.csv`: For each CSV data file on the design.
 */
export enum AvsFileName {
  /** Stores the value in `ccxml` of the @see design object. */
  appCcxml = 'app.ccxml',
  /** Stores the changes happened in the last 20 versions. */
  changeLogMaps = 'changeLogMaps.json',
  /** Stores the object used by D2 to create call flows. */
  design = 'design.json',
  /** Stores DSID information for each @see InputNodeModel objects in the @see design object. */
  dsids = 'dsids.json',
  /** Stores the file used by Process Engine to run a given version of a @see design. */
  export = 'export.json',
  /** Stores the string concatenated value in `functions` of the @see design object. */
  functions = 'functions.js',
  /** Stores values from @see InputNodeModel objects in the @see design object. */
  inputs = 'Inputs.csv',
  /**
   * Stores prompt text when omni-channel is off.
   *
   * @note If omni-channel is on, then prompts are stored in `Prompts_${channelName}.csv` files.
   */
  prompts = 'Prompts.csv',
  /** Stores unit test objects that are removed from the @see design object prior to save. */
  unitTests = 'unitTests.json'
}
